import { type FC, useMemo } from 'react';

import { GridLayout, useBreakpoint } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';
import { useDashboardRoute } from 'hooks/useDashboardRoute';

import { BalanceAndBonuses } from 'components/BalanceAndBonuses/BalanceAndBonuses';
import { PageContentHeader } from 'components/common/PageContentHeader/PageContentHeader';
import { Header } from 'components/Header/Header';

const TrlKeys = {
    title: 'BalanceAndBonuses.header',
    breadcrumbsLink: {
        main: 'Breadcrumbs.main',
        balanceAndBonuses: 'BalanceAndBonuses.header',
    },
};

export const BalanceAndBonusesPage: FC = () => {
    const { isMobile } = useBreakpoint();
    const trls = useTrls();
    const dashboardRoute = useDashboardRoute();

    const breadcrumbsConfig = useMemo(
        () => [
            { to: dashboardRoute, children: trls(TrlKeys.breadcrumbsLink.main) },
            { to: '#', children: trls(TrlKeys.breadcrumbsLink.balanceAndBonuses) },
        ],
        [dashboardRoute, trls]
    );

    return (
        <>
            <Header />
            <PageContentHeader
                breadcrumbsConfig={breadcrumbsConfig}
                title={trls('BalanceAndBonuses.header')}
                vSpacingBottom={isMobile ? 16 : 24}
            />
            <GridLayout>
                <BalanceAndBonuses />
            </GridLayout>
        </>
    );
};
